import AgentDepositModal from "./agent-deposit-modal";

export default AgentDepositModal;
